import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import BottomSheet from "./shared/BottomSheet";

function AccordionItem({ faq, index }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-slate-100 dark:border-slate-700/50 last:border-0">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-start gap-2.5 py-3.5 px-1 text-left transition-colors duration-150 active:bg-slate-50 dark:active:bg-slate-700/20"
      >
        <span className="h-5 w-5 rounded-full bg-brand/10 dark:bg-brand/15 text-brand text-[10px] font-bold flex items-center justify-center shrink-0 mt-0.5">
          {index + 1}
        </span>
        <span className="flex-1 text-[14px] font-semibold text-slate-800 dark:text-slate-100 leading-snug pr-2">
          {faq.q}
        </span>
        <ChevronDown
          size={14}
          className={`text-slate-400 dark:text-slate-500 shrink-0 mt-0.5 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>
      {open && (
        <div className="pb-3.5 pl-7 pr-1">
          <p className="text-[13px] text-slate-600 dark:text-slate-300 leading-relaxed">
            {faq.a}
          </p>
        </div>
      )}
    </div>
  );
}

export default function GuideSheet({ guide, onClose }) {
  if (!guide) return null;
  const Icon = guide.icon;

  return (
    <BottomSheet
      isOpen={true}
      onClose={onClose}
      title={guide.title}
      subtitle={guide.description}
      contentClassName="px-4 pb-6"
    >
      <div className="flex items-center gap-3 mb-4">
        <div className={`h-11 w-11 rounded-[14px] flex items-center justify-center shrink-0 ${guide.iconBg}`}>
          <Icon size={20} className={guide.iconColor} />
        </div>
        <div>
          <p className="text-[15px] font-bold text-slate-800 dark:text-slate-100 leading-tight">{guide.title}</p>
          <p className="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5">{guide.faqs.length} preguntas frecuentes</p>
        </div>
      </div>

      <div className="bg-white dark:bg-slate-800 rounded-[20px] border border-slate-200/50 dark:border-slate-700/50 px-3.5 divide-y divide-slate-100 dark:divide-slate-700/50">
        {guide.faqs.map((faq, i) => (
          <AccordionItem key={i} faq={faq} index={i} />
        ))}
      </div>
    </BottomSheet>
  );
}
